export const X_SMALL = 'xSmall';
export const SMALL = 'small';
export const MEDIUM = 'medium';
export const LARGE = 'large';
export const X_LARGE = 'xLarge';
export const TOGGLE = 'toggle';
export const RADIO = 'radio';
export const SLIDER = 'slider';
export const PILL = 'pill';
export const SELECT = 'select';
export const OPTION_TYPE_TRANSLATION = 'translation';
export const OPTION_TYPE_MEASUREMENT = 'measurement';
export const PAX = 'pax';
export const SINGLE_WALL = 'single_wall';
export const CORNER_WALL = 'corner_wall';
export const WALL = 'wall';
export const NO_DOOR = 'no_door';
export const DOOR_TYPE = 'door_type';
export const SIZE_DEPTH = 'size_depth';
export const SIZE_HEIGHT = 'size_height';
export const SIZE_WIDTH = 'size_width';
export const SIZE_WIDTH_SLIDING = 'size_width_sliding';
export const SIZE_WIDTH_SLIDING_LEFT = 'size_width_sliding_left';
export const SIZE_DEPTH_LEFT = 'size_depth_left';
export const SIZE_DEPTH_RIGHT = 'size_depth_right';
// The corner guide currently uses two separate sliders for the width value,
// one with a min value of 85cm and the other with min value 88cm.
export const SIZE_WIDTH_LEFT_85 = 'size_width_left_85';
export const SIZE_WIDTH_LEFT_88 = 'size_width_left_88';
export const SIZE_WIDTH_RIGHT_85 = 'size_width_right_85';
export const SIZE_WIDTH_RIGHT_88 = 'size_width_right_88';
export const SHALLOW_CONFIG = '35';
export const DEEP_CONFIG = '58';
export const SLIDING = 'sliding';
export const WALL_HEIGHT = {
    LOW: '201',
    HIGHT: '236'
};
export const FILTERED_TYPES = [
    'doors and fronts',
    'light strip',
    'light strip oversidan',
    'light cabel',
    'light driver',
    'light cord',
    'light controler',
    'cords and cables',
    'integrated lighting',
    'fittings',
    'handles and knobs',
    'wireless lighting'
];
export const WARDROBE_FRAME_TYPECODE = '11303';
//# sourceMappingURL=common.js.map